var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:{ active: _vm.active, 'menu-item-comp': true },attrs:{"to":_vm.to}},[_c('p',[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }